import { StopsByLine } from "./types";

export default function(stopsByLine: StopsByLine[]): any[] {
  let stopsByLineCategorised = [];
  const categories = [];
  Object.keys(stopsByLine).forEach(key => {
    const lineStops = stopsByLine[key];
    let category = lineStops.line.categ;
    if (!categories.includes(category)) {
      categories.push(category);
    }
    let categoryId = Object.keys(categories).find(key => categories[key] === category);
    if (!(categoryId in stopsByLineCategorised)) {
      stopsByLineCategorised[categoryId] = {
        category: '---',
        lineStops: [],
      };
    }
    stopsByLineCategorised[categoryId].category = (category !== "") ? category :  '---';
    stopsByLineCategorised[categoryId].lineStops.push(lineStops);
  })
  // Put empty category at the end of the array
  stopsByLineCategorised = stopsByLineCategorised.sort(function(a, b) {
    if (a.category === '---') {
      return 1;
    } else if (b.category === '---') {
      return -1;
    }
  });
  return stopsByLineCategorised;
}